import React, { useContext, useEffect, useState } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { Measurement } from "../classes/measurements/measurement";
import { ObservationGoalTemplate } from "../classes/goal_template_observation_class";
import { ObservationFormContext } from "../hooks/ObservationFormContext";

export const ObservationPreview: React.FunctionComponent = () => {
  const { goalState, setGoalState } = useContext(ObservationFormContext);
  const { t, DBObject } = useContext(TMDataContext);

  useEffect(() => {
    setGoalState((prevState) => {
      let newGoalObject = new ObservationGoalTemplate(prevState);
      return newGoalObject;
    });
  }, []);

  var measurement = Measurement.findById(goalState.measurementId);

  const showRepeatAmount = () => {
    return (
      <div className="goal-form-input-row preview-row ">
        <span className="goal-input-area-title preview-title">
          {t("views.goals.headings.occurrences")}
        </span>

        {goalState.continuous ? (
          <span className="goal-value-preview">
            {t("views.goals.contexts.occurrence_continuous")}
          </span>
        ) : (
          <>
            <span className="goal-value-preview">
              {t("views.goals.contexts.occur")}
            </span>
            <span className="goal-variables-preview">
              &nbsp;&nbsp;{goalState.occurrenceAmount}
              &nbsp;&nbsp;
            </span>
            <span className="goal-value-preview">
              {goalState.occurrenceAmount > 1
                ? t("views.goals.contexts.occur_times_multiple")
                : t("views.goals.contexts.occur_times_single")}{" "}
            </span>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="row w-100" style={{ flex: 1 }}>
      <div className="col-md-12 col-sm-6">
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.name")}
          </span>
          <span className="goal-value-preview">{goalState.name}</span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.user")}:
          </span>
          <span className="goal-value-preview">
            {goalState.user.lastName}, {goalState.user.firstName}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.type")}:
          </span>
          <span className="goal-value-preview">{goalState.type.label}</span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.description")}
          </span>
          <span style={{ maxWidth: "450px" }} className="goal-value-preview">
            {goalState.description == ""
              ? t("views.goals.contexts.no_description")
              : goalState.description}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.measurement_type")}:
          </span>
          <span className="goal-value-preview">
            {measurement.labelWithUnits()}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.target")}:
          </span>
          <span className="goal-value-preview">
            {goalState.achievementTarget}
            {measurement.unitsOnly()}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.achievement")}:
          </span>
          <span className="goal-value-preview">
            {t(
              `views.goals.contexts.${goalState.type.handle}.achievement_status_start`
            )}{" "}
            <span className="goal-variables-preview">
              {goalState.achievementCondition.label}
            </span>{" "}
            {t(`views.goals.contexts.${goalState.type.handle}.status_end`)}{" "}
            <span className="goal-variables-preview">
              {goalState.achievementTarget}
              {measurement.unitsOnly()}
            </span>
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.threshold")}
          </span>
          <span className="goal-value-preview">
            {goalState.achievementThreshold}%
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.occurrence_frequency")}
          </span>
          <span className="goal-value-preview">
            <span className="goal-variables-preview">
              {goalState.occurrenceFrequency.label}{" "}
            </span>
          </span>
        </div>
        {showRepeatAmount()}
        {DBObject.ConfigVariables.leaderboards_enabled == "true" ? (
          <div className="goal-form-input-row preview-row goal-form-no-underline">
            <span className="goal-input-area-title preview-title">
              {t("views.goals.headings.leaderboard")}
            </span>
            <span className="goal-value-preview">
              {goalState.leaderboardEnabled
                ? t("views.goals.contexts.Leaderboard.enabled")
                : t("views.goals.contexts.Leaderboard.disabled")}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
